import { Component, OnInit, Input } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-feather-icons',
  templateUrl: './feather-icons.component.html',
  styleUrls: ['./feather-icons.component.scss']
})
export class FeatherIconsComponent implements OnInit {

  private _icon = 'circle';

  @Input('icon')
  set icon(value: string) {
    // Fallback to a safe default when the icon name is missing/invalid to prevent feather errors
    this._icon = value && feather.icons[value] ? value : 'circle';
  }

  get icon(): string {
    return this._icon;
  }

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

}
